import { Locale } from "@dashboard/components/Locale";
import useLocale from "@dashboard/hooks/useLocale";
import { Box, Button } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { portalLabels as l } from "./labels";

// The portal speaks Portuguese and Simplified Chinese.
const LANGUAGES: Array<[Locale, string]> = [
  [Locale.PT, "PT"],
  [Locale.ZH_HANS, "中文"],
];

export const LanguageSwitch = () => {
  const intl = useIntl();
  const { locale, setLocale } = useLocale();

  return (
    <Box display="flex" gap={1} title={intl.formatMessage(l.language)}>
      {LANGUAGES.map(([code, label]) => (
        <Button
          key={code}
          size="small"
          variant={locale === code ? "secondary" : "tertiary"}
          onClick={() => {
            if (locale !== code) {
              setLocale(code);
              // The locale provider loads a catalogue only once per page.
              window.location.reload();
            }
          }}
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};
